<div *ngIf="item" class="container-fluid">
  <div *ngIf="item.item_ID">
    <div mat-dialog-title>Edit Item</div>
    <div class="form-inline mb-2">
      <span class="col-xs-12">Make the necessary changes on the form below then click Submit</span>
      <div class="float-right form-inline">
        <div class="col-xs-12">
          <span class="col-xs-12 col-sm-4 warning">
            * Required Information
          </span>
          <div class="float-right" *ngIf="canDeleteItem">
            <button (click)="deleteItem(item.item_ID)" class="btn btn-bidit-cancel btn-sm" type="button">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!item.item_ID">
    <div mat-dialog-title>Add Item</div>
    <div class="form-inline row mb-2">
      <span class="col-sm-8">To add a new Item, complete the form below then click Submit.</span>
      <span class="float-right warning col-sm-4">
        * Required Information
      </span>
    </div>
  </div>

  <div class="row" mat-dialog-content>
    <form #form="ngForm" (ngSubmit)="saveItemSource(form)">
      <div class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="pr-3" for="item_Name">Name</label>
            <input id="item_Name" name="item_Name" class="form-control col" [(ngModel)]="item.item_Name"
                   required #item_Name="ngModel"
                   [class.field-error]="form.submitted && item_Name.invalid">
            <div [hidden]="!form.submitted || item_Name.valid"
                 class="alert alert-danger">
              Name is required
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <label class="pr-3" for="item_SalesDesc">Sales Description</label>
            <textarea id="item_SalesDesc" name="item_SalesDesc" class="col form-control" [(ngModel)]="item.item_SalesDesc"
                      #item_SalesDesc="ngModel">
            </textarea>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="form-group form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="pr-3" for="itemTypes">Item Type</label>
            <select name="item_Type" id="item_Type" class="form-control select-bidit" (ngModelChange)="onItemTypeChange($event)"
                    [(ngModel)]="item.itemType_ID" required #item_Type="ngModel">
              <option [ngValue]="null" selected="">-</option>
              <option *ngFor="let type of itemTypes" [(ngValue)]="type.itemType_ID" [disabled]="!type.itemType_IsActive">{{type.itemType_Desc}}</option>
            </select>
            <div [hidden]="!form.submitted || item_Type.valid"
                 class="alert alert-danger">
              Item Type is required
            </div>
          </div>
        </div>
        <div class="form-group form-inline">
          <label class="pr-3" for="rValues">R Value</label>
          <select name="rValues" id="rValues" class="form-control select-bidit" [(ngModel)]="item.rValue_ID">
            <option [ngValue]="null" selected="">-</option>
            <option *ngFor="let rvalue of rValues" [(ngValue)]="rvalue.rValue_ID">{{rvalue.rValue_Desc}}</option>
          </select>
        </div>
      </div>
      <div *ngIf="!showItemCoverage && !showAeroBarrier" class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <span *ngIf="itemTypeRequired" class="warning">* </span>
            <label class="pr-3" for="item_SqrFtPerUnit">Square Feet Per Unit</label>
            <input type="number" step="0.01" min="0" id="item_SqrFtPerUnit" name="item_SqrFtPerUnit" class="form-control" [(ngModel)]="item.item_SqrFtPerUnit"
                   required="{{itemTypeRequired}}" #item_SqrFtPerUnit="ngModel"
                   [class.field-error]="form.submitted &&item_SqrFtPerUnit.invalid">
            <div [hidden]="!form.submitted || item_SqrFtPerUnit.valid"
                 class="alert alert-danger">
              Square feet per unit is required
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!showAeroBarrier" class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="pr-3" for="item_Cost">
              Item Cost Per
              <ng-container [ngSwitch]="item.itemType?.itemCoverageType_ID">
                <ng-container *ngSwitchCase="1">Bag</ng-container>
                <ng-container *ngSwitchCase="2">Set</ng-container>
                <ng-container *ngSwitchCase="3">Sqr Ft</ng-container>
                <ng-container *ngSwitchDefault>Unit</ng-container>
              </ng-container>
            </label>
            <input type="number" step="0.01" min="0" id="item_Cost" name="item_Cost" class="form-control"
                   [(ngModel)]="item.item_Cost"
                   #item_Cost="ngModel"
                   [class.field-error]="form.submitted &&item_Cost.invalid">            
          </div>
        </div>
      </div>
      <div *ngIf="showAeroBarrier">
        <div class="form-group row">
          <div class="col-md-12 form-inline">
            <div class="control-wrapper">
              <span class="warning">* </span>
              <label class="pr-3" for="item_SqrFtUpt" i18n>SQFT up to</label>
              <input type="number" step="0.01" min="0" id="item_SqrFtUpto"
                     name="item_SqrFt_Upto" class="form-control" [(ngModel)]="item.item_SqrFt_Upto"
                     required #item_SqrFt_Upto="ngModel" [disabled]="!this.isIDIAdmin"
                     [class.field-error]="form.submitted && item_SqrFt_Upto.invalid">
              <div [hidden]="!form.submitted || item_SqrFt_Upto.valid"
                   class="alert alert-danger" i18n>SQFT up to is required</div>
            </div>
          </div>
        </div>
        <div class="form-group form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label class="pr-3" for="item_Cost_SqrFt">
              <span i18n>Item Cost Per Sqr Ft </span>
            </label>
            <input type="number" step="0.01" min="0" id="item_Cost_SqrFt" name="item_Cost_SqrFt" class="form-control"
                   [(ngModel)]="item.item_Cost_SqrFt" (ngModelChange)="populateCost()" [disabled]="!this.isIDIAdmin"
                   required #item_Cost_SqrFt="ngModel"
                   [class.field-error]="form.submitted &&item_Cost_SqrFt.invalid">
            <div [hidden]="!form.submitted || item_Cost_SqrFt.valid"
                 class="col-md-12 alert alert-danger" i18n>Item Cost is required</div>
          </div>
        </div>
        <div class="form-group form-inline">
          <div class="control-wrapper">
            <label class="pr-3" for="item_Cost_SqrFt_Overrage">
              <span i18n>Item Cost Per Sqr Ft Overrage </span>
            </label>
            <input type="number" step="0.01" min="0" id="item_Cost_SqrFt_Overrage" name="item_Cost_SqrFt_Overrage" class="form-control"
                   [(ngModel)]="item.item_Cost_SqrFt_Overrage" [disabled]="!this.isIDIAdmin">
          </div>
        </div>
      </div>
      <div class="form-group form-inline">
        <div class="control-wrapper">          
          <label class="pr-3" for="item_Part">Original Mfg Part #</label>
          <input id="item_Part" name="item_Part" class="form-control" [(ngModel)]="item.item_Part"
                 required disabled="disabled"
                 #item_Part="ngModel"
                 [class.field-error]="form.submitted &&item_Part">          
        </div>
      </div>
      <div class="form-group form-inline">
        <div class="control-wrapper">
          <span class="warning">* </span>
          <label class="pr-3" for="external_Item_Part">Manufacturer Part #</label>
          <input id="external_Item_Part" name="external_Item_Part" class="form-control" [(ngModel)]="item.external_Item_Part"
                 required
                 #external_Item_Part="ngModel"
                 [class.field-error]="form.submitted && external_Item_Part">
          <div [hidden]="!form.submitted || external_Item_Part.valid"
               class="alert alert-danger">
            Part number is invalid
          </div>
        </div>
      </div>

      <mat-dialog-actions align-items-end>
        <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit btn-md mr-3">Submit</button>
        <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md">Cancel</a>
      </mat-dialog-actions>
      <app-spinner [isRunning]="isRequesting"></app-spinner>

      <div class="mt-3">
        <div [hidden]="!form.submitted || form.valid"
             class="alert alert-danger">
          Validation issues encountered.  Please review your entered information.
        </div>
      </div>
    </form>
  </div>
</div>

